export default "__VITE_ASSET__2d82b175__"